import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	title: {
		color: theme.palette.neutral[60],
		marginBottom: theme.spacing.medium,
	},
	headerImage: {
		marginBottom: theme.spacing.medium,
		position: 'relative',
	},
	imageTitle: {
		zIndex: 11,
		position: 'absolute',
		height: '100%',
		margin: 0,
		display: 'flex',
		alignItems: 'center',
		paddingLeft: theme.spacing.medium,
		maxWidth: '43%',
		minWidth: '350px',
		wordBreak: 'break-word',
		color: theme.palette.neutral[0],
	},
	headerContainer: {
		position: 'relative',
	},
}));
